import { type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

interface ClientPortalButtonProps {
  clientPortalId?: string;
}

export function ClientPortalButton({ clientPortalId }: ClientPortalButtonProps): ReactNode {
  if (!clientPortalId) {
    return null;
  }

  return (
    <a
      className="btn"
      data-test-client-portal-cta
      data-testid="client-portal-cta"
      href={`/clients/${clientPortalId}`}
      type="button"
    >
      <FormattedMessage id="quote.preview.cta.portal" />
    </a>
  );
}
